import styled, { keyframes } from 'styled-components';
import { useEffect, useState } from 'react';

// Components
import FormRefered from '../FormRefered';
import CommonButton from '../../../../components/common/CommonButton';
import toast from 'react-hot-toast';

// Material
import { Card, Dialog } from '@mui/material';
import { Link } from '@mui/icons-material';

// Redux
import { getCountries } from '../../../../redux/api/utils';
import { useSelector } from 'react-redux';
import {
    EmailIcon,
    EmailShareButton,
    FacebookIcon,
    FacebookMessengerShareButton,
    LinkedinIcon,
    LinkedinShareButton,
    TwitterShareButton,
    WhatsappIcon,
    WhatsappShareButton,
    XIcon,
} from 'react-share';
import { referralCopyLink } from '../../../../redux/api/behaviour/referrals';

const BannerReferred = (props) => {
    const { user } = useSelector((state) => state.auth);
    const { repoId } = props;

    const [open, setOpen] = useState(false);
    const [countries, setCountries] = useState(null);

    const handleModal = () => {
        setOpen(!open);
    };

    useEffect(() => {
        !countries && getCountry();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // FUNCTIONS
    const getCountry = async () => {
        try {
            const request = await getCountries();
            setCountries(request.data.response_data);
        } catch (error) {}
    };

    const getInvitationLink = () => {
        const baseUrl = window.location.origin;
        return `${baseUrl.replace('/mis-referidos', '')}/invitado/${repoId}`;
    };

    const handleCopyLink = async () => {
        const invitationLink = getInvitationLink();
        referralCopyLink({ partner_id: repoId });

        try {
            await navigator.clipboard.writeText(invitationLink);
            toast.success('Enlace de invitación copiado!', {
                icon: <Link />,
                style: {
                    border: '2px solid #4BB543',
                    padding: '16px',
                    color: '#000',
                    fontWeight: 'bold',
                },
            });
        } catch (err) {
            console.error('Error al copiar el enlace:', err);
        }
    };

    return (
        <CardFake>
            <Dialog open={open} onClose={handleModal}>
                <FormRefered
                    countries={countries}
                    student={user}
                    misReferidos={true}
                />
            </Dialog>
            <h2>
                Comparte, expande y crece con el <b>"Programa de Invitados"</b>
            </h2>
            <p>
                ¡Sigamos impulsando el talento y la prosperidad de la comunidad
                latinoamericana!
                <br />
                Queremos que más ejecutivos vivan la experiencia ADEN.
            </p>
            <p>
                <b>
                    Invita a un colega, amigo o familiar y obtén increíbles
                    beneficios.
                </b>
            </p>
            <ShareContainer>
                <CommonButton
                    onClick={(e) => {
                        e.stopPropagation();
                        handleCopyLink();
                    }}
                    variant="filled"
                    label="Copiar enlace de invitación"
                />
                <ShareSocialMedia>
                    <LinkedinShareButton url={getInvitationLink()}>
                        <LinkedinIcon size={40} round={true} />
                    </LinkedinShareButton>
                    <FacebookMessengerShareButton url={getInvitationLink()}>
                        <FacebookIcon size={40} round={true} />
                    </FacebookMessengerShareButton>
                    <TwitterShareButton url={getInvitationLink()}>
                        <XIcon size={40} round={true} />
                    </TwitterShareButton>
                    <WhatsappShareButton url={getInvitationLink()}>
                        <WhatsappIcon size={40} round={true} />
                    </WhatsappShareButton>
                    <EmailShareButton url={getInvitationLink()}>
                        <EmailIcon
                            size={40}
                            round={true}
                            bgStyle={{ fill: '#b31d15' }}
                        />
                    </EmailShareButton>
                </ShareSocialMedia>
            </ShareContainer>
        </CardFake>
    );
};

export default BannerReferred;

const addOutline = keyframes`
    0% {
        outline: none;
    }
    16% {
        outline: 1px solid #D5D5D5;
    }
    32% {
        outline: 2px solid #D5D5D5;
    }
    48% {
        outline: 3px solid #D5D5D5;
    }
    64% {
        outline: 4px solid #D5D5D5;
    }
    80% {
        outline: 5px solid #D5D5D5;
    }
    100% {
        outline: 6px solid #D5D5D5;
    }
`;

const CardFake = styled(Card)`
    position: relative;
    border-radius: 20px;
    width: 60%;
    padding: 2rem;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: start;
    background: #ffffff;
    box-shadow:
        0px 3px 6px 0px #0000003b,
        0px 3px 6px 0px #00000029;
    border-radius: 20px;
    border: 1px solid #a8a8a8;
    z-index: 1;

    h2 {
        color: #b31d15;
        font-size: 24px;
    }

    p {
        color: #000000;
        font-size: 20px;
    }

    button {
        cursor: pointer;
        height: 44px;
        padding: 0 1rem;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
        background-color: #cd2118;
        color: #ffffff;
        border-radius: 100px;
        animation: ${addOutline} 0.5s infinite alternate;
    }

    @media (max-width: 768px) {
        width: 100%;
        gap: 1.5rem;
    }
`;

const ShareContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (max-width: 768px) {
        flex-direction: column;
        gap: 1.5rem;
    }
`;

const ShareSocialMedia = styled.div`
    display: flex;
    gap: 1rem;

    @media (max-width: 768px) {
        width: 100%;
        justify-content: space-around;
    }
`;
